import { DEVICES_REGEXP } from './regexp';

const { ios, android, mac, windowsPhone, windows, ubuntu, mobile } = DEVICES_REGEXP;

const userAgent = navigator.userAgent || navigator.vendor || window.opera;

const isIOS = ios.test(userAgent) && !window.MSStream;

const isAndroid = android.test(userAgent);

const isMac = mac.test(userAgent);

const isWindowsPhone = windowsPhone.test(userAgent);

const isWindows = windows.test(userAgent);

const isUbuntu = ubuntu.test(userAgent);

const isMobile = mobile.test(navigator.userAgent);

export { isIOS, isMobile, isAndroid, isWindowsPhone, isMac, isUbuntu, isWindows, userAgent };
